module.exports = __webpack_public_path__ + "media/img/frontend_application/eventtype/seminar-36588811e2686ca45e236ccffd3f4c25.jpg";